import axios from 'axios'
import { REMOTE_PATHS } from './constants/remotePaths.constant'

const getHeaders = token => {
  return {
    Accept: 'application/x-protobuf',
    Authorization: `Bearer ${token}`,
  }
}

const getHeadersPost = token => {
  return {
    Accept: 'application/x-protobuf',
    'Content-Type': 'application/x-protobuf',
    'Auth-token': `Bearer ${token}`,
  }
}

const constructPath = path => {
  return `${REMOTE_PATHS.API_PATH}${path}`
}

export const api = {
  _post({ path, params, json, token }) {
    const headers = getHeadersPost(token)
    return axios.post(
      constructPath(path),
      json ? params : new Uint8Array(params),
      {
        headers,
      }
    )
  },
  _get({ path, params, json, token }) {
    const headers = getHeaders(token)
    return axios.get(constructPath(path), {
      headers,
      params,
      responseType: json ? 'application/json' : 'arraybuffer',
    })
  },
  getWebRtcToken({ token }) {
    return this._get({ path: '/api/v1/webrtc/token', json: true, token })
  },
  getUserInfo(data) {
    return this._get({ path: `/api/users/${data.userId}`, noAuth: true })
  },
  userOpinions(data, token) {
    return this._post({
      path: `/calls/api/call_summaries`,
      data,
      json: false,
      token,
    })
  },
}
